import React from "react";
var __jsx = React.createElement;
import { createContext, useEffect, useState } from 'react';
import bind from '../utils/bind';
import { globalBinder } from '../utils/container';
const context = /*#__PURE__*/createContext(globalBinder.container());

function ContainerProvider(props) {
  const {
    0: isReady,
    1: setReady
  } = useState(false);
  useEffect(() => {
    bind(globalBinder).then(() => {
      setReady(true);
    }).catch(error => {
      throw error;
    });
  }, []);
  return __jsx(React.Fragment, null, isReady && globalBinder && context && __jsx(context.Provider, {
    value: globalBinder.container()
  }, props.children));
}

export default ContainerProvider;